// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2gBiU","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__yrxNN","gfeWrapper":"CalendarEvent_gfeWrapper__NXo8z"};